export function initFaqAccordion(): void {
  const faqContainer = document.getElementById('faq-accordion')
  if (!faqContainer) return

  const questions = faqContainer.querySelectorAll('.faq-question')

  questions.forEach(question => {
    question.addEventListener('click', () => {
      const faqId = question.getAttribute('data-faq')
      if (!faqId) return

      const answer = faqContainer.querySelector(`[data-faq-content="${faqId}"]`)
      const icon = question.querySelector('.faq-icon')

      if (!answer) return

      const isExpanded = answer.classList.contains('expanded')

      // Close all other items
      faqContainer.querySelectorAll('.faq-answer').forEach(item => {
        item.classList.remove('expanded')
        item.classList.add('collapsed')
      })
      faqContainer.querySelectorAll('.faq-icon').forEach(item => {
        item.classList.remove('rotate-180')
      })

      // Toggle current item
      if (!isExpanded) {
        answer.classList.remove('collapsed')
        answer.classList.add('expanded')
        icon?.classList.add('rotate-180')
      }
    })
  })

  // Allow keyboard navigation
  questions.forEach(question => {
    question.addEventListener('keydown', (e: Event) => {
      const keyEvent = e as KeyboardEvent
      if (keyEvent.key === 'Enter' || keyEvent.key === ' ') {
        e.preventDefault()
        ;(question as HTMLElement).click()
      }
    })
  })
}
